import { useEffect, useState } from "react";
import { RegistryPage } from "../registry/sitePageRegistry";
import { fetchSeoPageDefinitions } from "../services/seoPageDefinitions";

// Backend-driven replacement for the old hardcoded sitePageRegistry.ts array.
// Definitions/variables are entered via Django admin only (SEOPageDefinition,
// SEOPageVariable) — this just fetches and reshapes them into the same
// RegistryPage/RegistryVariable shape every editor card already consumes.
export const useSitePageDefinitions = (siteId: number) => {
  const [pages, setPages] = useState<RegistryPage[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!Number.isFinite(siteId)) return;
    let cancelled = false;
    setLoading(true);

    fetchSeoPageDefinitions(siteId)
      .then((response) => {
        if (cancelled) return;
        const shaped: RegistryPage[] = (response.data.results || []).map((definition) => ({
          key: definition.page_key,
          label: definition.label,
          path: definition.path_pattern,
          isDynamic: definition.is_dynamic,
          variables: [...definition.variables]
            .sort((a, b) => a.display_order - b.display_order)
            .map((variable) => ({ key: variable.key, label: variable.label, sample: variable.sample })),
        }));
        setPages(shaped);
      })
      .catch((error) => {
        console.error("Failed to load SEO page definitions", error);
      })
      .finally(() => {
        if (!cancelled) setLoading(false);
      });

    return () => {
      cancelled = true;
    };
  }, [siteId]);

  return { pages, loading };
};
